import React from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTERS } from 'src/shared/constants/routers';
import { PublicLayout } from 'src/layouts';
import { LoginScreen, RegisterScreen } from 'src/screens/publicScreens';
import NotFoundScreen from 'src/screens/errorPage/notFound';

const _publicRoutes: RouteObject[] = [
  {
    path: ROUTERS.HOME.PATH,
    element: <PublicLayout />,
    children: [
      { path: ROUTERS.LOGIN.PATH, element: <LoginScreen /> },
      { path: ROUTERS.REGISTER.PATH, element: <RegisterScreen /> },
      { path: ROUTERS.RESET_PASSWORD.PATH, element: <RegisterScreen /> },
      { path: ROUTERS.REMIND_CHANGE_PASSWORD.PATH, element: <RegisterScreen /> },
    ],
  },
  { element: <NotFoundScreen />, path: '*' },
];

export default _publicRoutes;
